export class User {
  merchantUserId?: number;
  merchantUserEmail?: number;
  managerName?: string;
  merchantUserMobileNo?: string;
  shop?: any;
  merchantUserStatus?: string;
  constructor(Obj: any = {}) {
    this.merchantUserId = Obj.merchantUserId;
    this.merchantUserEmail = Obj.merchantUserEmail;
    this.managerName =  Obj.managerName;
    this.shop = Obj.shop;
    this.merchantUserStatus = Obj.merchantUserStatus;
    this.merchantUserMobileNo = Obj.merchantUserMobileNo;
  }
}
